import { render, staticRenderFns } from "./orderServicerToquote.vue?vue&type=template&id=1ac47e10&"
import script from "./orderServicerToquote.vue?vue&type=script&lang=ts&"
export * from "./orderServicerToquote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports